module.exports = "close_all"